
import React, { useState,useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import config from "../../config/config";
import { toast } from "react-toastify";
import { MdOutlineEmail } from "react-icons/md";
import { CiLock } from "react-icons/ci";
import { MdMemory } from "react-icons/md";
import { BsChevronCompactLeft } from "react-icons/bs";
import { LuLogIn } from "react-icons/lu";
import "./OperatorLogin.css";
export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

// useEffect(() => {
//   const storedUser = localStorage.getItem("user");
//   if (storedUser) {
//     const user = JSON.parse(storedUser);
//     // console.log(user?.access_token, "token");
//     if (user?.access_token) {
//       const role = user?.user?.role;
//       switch (role) {
//         case "senior_manager":
//           navigate("/senior-management");
//           break;
//         case "inspection":
//           navigate("/inspection-dashboard");
//           break;
//         case "manager":
//           navigate("/management-dashboard");
//           break;
//         case "supervisor":
//           navigate("/supervisor-dashboard");
//           break;
//         case "admin":
//           navigate("/admin");
//           break;
//         default:
//           break;

//       }
//     }
//   }
// }, [navigate]);

useEffect(() => {
  const storedUser = localStorage.getItem("user");

  if (storedUser) {
    const user = JSON.parse(storedUser);

    if (user?.access_token) {

      const role = user?.user?.role;

      switch (role) {

        case "operator":
          navigate("/dashboard");
          break;

        case "senior_manager":
          navigate("/senior-management");
          break;

        case "inspection":
          navigate("/inspection-dashboard");
          break;

        case "manager":
          navigate("/management-dashboard");
          break;

        case "supervisor":
          navigate("/supervisor-dashboard");
          break;

        case "admin":
          navigate("/admin");
          break;

        default:
          navigate("/login");
      }
    }
  }
}, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${config.API}/auth/login`, {
        email,
        password,
      });
      const userData = response?.data;
      localStorage.setItem("user", JSON.stringify(userData));
      const name = userData?.user?.name || "User";
      const role = userData?.user?.role;
      toast.success(`Login ${name} successfully`);
      setTimeout(() => {
        switch (role) {
          case "senior_manager":
            navigate("/senior-management");
            break;
          case "inspection":
            navigate("/inspection-dashboard");
            break;
          case "manager":
            navigate("/management-dashboard");
            break;
          case "supervisor":
            navigate("/supervisor-dashboard");
            break;
          case "admin":
            navigate("/admin");
            break;
          default:
            toast.error("Unknown user role");
        }
      }, 400);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        "Login failed. Please try again."
      );
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        {/* LEFT PANEL */}
        <div className="left-panel font_family">
          <div className="left-content">
            <div className="d-flex align-items-center gap-3">
              <div
                className="d-flex align-items-center justify-content-center fs-2"
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "12px",
                  background: "linear-gradient(145deg, rgba(248,249,251,0.65), rgba(238,243,242,0.65))",
                  color: "#fff",
                }}
              >
                <MdMemory/>
              </div>
              <div
                className="brand mt-3"
              >
                PRAG
              </div>
            </div>
            <h1>Prag Production<br />System</h1>
            <p className="fw-bold">
              Industrial monitoring and control interface.
            </p>
            <div className="dev-text">
              DESIGNED AND DEVELOPED BY KENSAA
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="right-panel font_family">
          <div className="m-4">
            <div className="switch">
              <Link to="/" style={{ textDecoration: "none", color: "black" }}><BsChevronCompactLeft /> Back to Operator Login </Link>
            </div>
            <h2 className="fw-bold text-center text-md-start mt-4">
              System Login
            </h2>

            <p className="text-center text-md-start">
              Login for Manager and Supervisor
            </p>
            <form onSubmit={handleLogin} className="mt-4">
              {/* Email */}
              <span>User Name</span>
              <div className="single-input">
                <span className="input-icon">
                  <MdOutlineEmail />
                </span>
                <input
                  type="email"
                  placeholder="Username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              {/* Password */}
              <span>Password</span>
              <div className="position-relative mb-4">
                <div className="single-input">
                  <span className="input-icon">
                    <CiLock />
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6c757d"
                  }}
                >
                  {showPassword ? <EyeSlash size={22} /> : <Eye size={22} />}
                </span>
              </div>

              {/* Button */}
              <button
                type="submit"
                className="btn btn-primary btn-lg w-100 rounded-3"
              >
               <LuLogIn/> Login
              </button>
            </form>
            <p
              className="d-block text-center mt-5 text-decoration-none"
            >
              Access restricted to authorized personnel only.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}